import { apiManagementService } from '../../services/service-factory';

export default {
  data: function() {
    return {
      apiManagementService: undefined
    };
  },
  created: function() {
    this.apiManagementService = apiManagementService;
  }
};
